import { DMCObject } from "./DMCObject";
import Konva from "konva";
import store from "../../../store/store";

export class DMCButton extends DMCObject {
  constructor(name, konvaObject, nameProject) {
    super(name, konvaObject);
    this.nameProject = nameProject;
  }

  copyOption(DMCObject, controllerProject) {
    this.nameProject = DMCObject.nameProject;
    const newOption = super.copyOption(DMCObject, controllerProject);

    return newOption;
  }

  createNewObject(DMCObject) {
    let rect = new Konva.Rect(DMCObject.konvaObjectOption);
    const nameProject = this.nameProject;
    rect.on("mouseup touchend", () => {
      store.dispatch("buttonClicked", nameProject).creation;
    });
    rect.opacity(0.5);
    return rect;
  }

  getType() {
    return "Button";
  }

  loadEnd(obj) {
    const color = obj.konvaObjectOption.fill;
    this.setColor(color);
    return obj;
  }

  // eslint-disable-next-line no-unused-vars
  renderPreview(layer = null) {
    this.renderObject = this.konvaObject.clone();
    store.dispatch("buttonReset").creation;

    this.renderObject.attrs.draggable = false;
    this.renderObject.attrs.fill = null;
    this.renderObject.attrs.stroke = null;
    this.renderObject.attrs.dragBoundFunc = function () {
      return {
        x: this.absolutePosition().x,
        y: this.absolutePosition().y,
      };
    };

    return {
      object: this.renderObject,
      zIndex: 999,
    };
  }

  // Setters
  setColor(val) {
    this.konvaObject.setAttr("fill", val);
    return val;
  }
}
